export default "__VITE_ASSET__BeU_D0KX__"